/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getMatches.defs.js'
export { main as default } from './getMatches.defs.js'
